import { isNaN, isNil } from 'lodash-es';
import { format, isValid, parse } from 'date-fns';
export class DatePatternConverter {
    constructor(format) {
        this._format = format;
        this._formatNotSpecified = isNil(this._format) || this._format === '';
    }
    getMask() {
        const separator = this.patternSeparator();
        if (this._formatNotSpecified) {
            const formatter = new Intl.DateTimeFormat();
            return formatter
                .format(new Date())
                .replaceAll(/[0-9]/g, '_')
                .replaceAll(/[^_]/g, separator);
        }
        return format(new Date(), this._format)
            .replaceAll(/[0-9]/g, '_')
            .replaceAll(/[^_]/g, separator);
    }
    getFormattedDate(dateStr) {
        if (isNil(dateStr) || dateStr === '') {
            return this.getMask();
        }
        const date = this._format ? parse(dateStr, this._format, new Date()) : new Date(dateStr);
        if (isNaN(date.getTime())) {
            return this.getMask();
        }
        if (this._formatNotSpecified) {
            const formatter = new Intl.DateTimeFormat(undefined, {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            });
            return formatter.format(date);
        }
        return format(date, this._format);
    }
    checkDateCursor(cursorPos) {
        if (this._formatNotSpecified) {
            return 'UnKnown';
        }
        if (cursorPos < 0 || cursorPos >= this._format.length) {
            return 'OnYear';
        }
        if (this.patternSeparator() === this._format[cursorPos]) {
            cursorPos--;
        }
        if (this._format[cursorPos].toLowerCase() === 'm') {
            return 'OnMonth';
        }
        if (this._format[cursorPos].toLowerCase() === 'd') {
            return 'OnDay';
        }
        if (this._format[cursorPos].toLowerCase() === 'y') {
            return 'OnYear';
        }
        return 'UnKnown';
    }
    isDateValid(value) {
        if (this._formatNotSpecified) {
            const date = new Date(value);
            return isNaN(date.getTime());
        }
        const parsedDate = parse(value, this._format, new Date());
        return isValid(parsedDate) && parsedDate.toString() !== 'Invalid Date';
    }
    patternSeparator() {
        if (this._formatNotSpecified) {
            const date = new Date();
            const formatter = new Intl.DateTimeFormat(undefined, {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            });
            const parts = formatter.formatToParts(new Date(formatter.format(date)));
            let dateSeparator = '';
            for (const part of parts) {
                if (part.type === 'literal' && part.value.trim() !== '') {
                    dateSeparator = part.value;
                    break;
                }
            }
            return dateSeparator;
        }
        if (this._format.includes('/')) {
            return '/';
        }
        if (this._format.includes('.')) {
            return '.';
        }
        if (this._format.includes('-')) {
            return '-';
        }
        if (this._format.includes(',')) {
            return ',';
        }
        return '/';
    }
}
